import { Box, Typography } from "@mui/material";
import * as React from "react";
import Modal, { CommonModalProps } from "..";
import MovieCard, { MovieCardGrid, MovieCardProps } from "../../Cards/MovieCard/movie-card";
import BrowsingData from "../../../Static/Data/browsing.json";
import ListPageHeader, { ListPageHeaderLeft, ListPageHeaderRight } from "../../Misc/ListPageHeader";
import SearchExpand from "../../Misc/SearchExpand/search-expand";
import SelectSortBy from "../../Misc/SelectSortBy";
import ToggleLayout from "../../Misc/ToggleLayout";
import FiltersList from "../../Filters/FiltersList/filters-list";
import Hero from "../../Misc/Hero";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import { MetadataFieldValueObjectTypes } from "../../../Core/Api/Types/metadata-field-value-object-types";
import { useTranslation } from "react-i18next";

export type ModalPreviewCollectionElementProps = {
  collectionId?: number;
};

export type ModalPreviewCollectionProps = CommonModalProps<ModalPreviewCollectionElementProps>;

const ModalPreviewCollection = React.forwardRef<any, ModalPreviewCollectionProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal } = props;

  const movieCardsData: Omit<MovieCardProps, "index">[] = BrowsingData.movie.map((movie) => ({
    id: movie.id,
    to: "#",
    cover: `/static/images/temp/${movie.cover}`,
    title: movie.title,
    labelList: movie.labels,
    quality: movie.quality,
    favorite: movie.favorite,
    expand: {
      contentList: movie.content,
      audioList: movie.audio,
      subtitleList: movie.subtitle,
      tagList: movie.content,
      quality: movie.bestQuality,
    },
    selectMode: true,
  }));

  return (
    <Modal
      title={t("modal:title.previewWindow")}
      reference={ref}
      closeModal={closeModal}
      width={1080}
      background="default"
    >
      <Hero src="/static/images/temp/title-cover.jpg" sx={{ top: 0 }} />
      <Box sx={{ position: "relative" }}>
        <Box mb="200px"></Box>
        <ListPageHeader mb={1} sx={{ pointerEvents: "none" }}>
          <ListPageHeaderLeft title={t("page:title.moviesForChristmas")} />
          <ListPageHeaderRight>
            <SearchExpand />
            <SelectSortBy />
            <ToggleLayout value="grid" />
          </ListPageHeaderRight>
        </ListPageHeader>
        <FiltersList
          sx={{ mb: 4, pointerEvents: "none" }}
          layer={ObjectLayer.Title}
          type={MetadataFieldValueObjectTypes.DbAssetObjectInfos}
        />
        <Typography mb={2} color="text.secondary">
          {t("page:body.titlesWithCount", { count: 1250 })}
        </Typography>
      </Box>

      <MovieCardGrid
        sx={{
          pointerEvents: "none",
        }}
      >
        {movieCardsData.map((movie, index) => (
          <MovieCard {...movie} key={movie.id} />
        ))}
      </MovieCardGrid>
    </Modal>
  );
});

export default ModalPreviewCollection;
